import { useEffect } from 'react';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildGetAccountUserOfferingsRequest } from '../utils';
import { ACTIONS } from '../state/actions';

const useUserOfferings = ({ accountId, dispatch, user }) => {
  const {
    data: userOfferingsData,
    error: userOfferingsDataError,
    doFetch: doFetchUserOfferings,
    loading: isFetchingUserOfferings,
    setData: setUserOfferings,
  } = useDataApi();

  useEffect(() => {
    if (user && accountId) {
      dispatch({
        type: ACTIONS.RESET_SUBSCRIPTION_DATA,
      });
      doFetchUserOfferings(
        buildGetAccountUserOfferingsRequest(user.id, accountId)
      );
    }
  }, [user, accountId, doFetchUserOfferings, dispatch]);

  return {
    doFetchUserOfferings,
    isFetchingUserOfferings,
    userOfferingsData,
    userOfferingsDataError,
    setUserOfferings,
  };
};

export default useUserOfferings;
